const shouldHaveGroup = "_35ss1e992jj";
const stateBox = "_35ss1u4ts0w";

export { shouldHaveGroup, stateBox };
import "./input.text.style.linaria.module.css";
//# sourceMappingURL=input.text.style.js.map
